'use client'
import {
  DocHeading,
  DocSimpleParagraph,
  DocSubHeading,
} from '@/components/ui/formatting'
import styles from './index.module.css'
export default function ApplicationHeader() {
  return (
    <div className="mb-10 px-8">
      <div className="flex flex-col md:flex-row items-center md:space-x-4 py-4">
        <div className="flex flex-col justify-between w-full">
          <div data-section id="getting-started">
            <div className="flex justify-between">
              <div>
                <DocSubHeading text={`Navigating AI Futures`} />
                <div className="flex items-center gap-4 mt-3">
                  <DocHeading text={'The Companies'} />
                </div>
              </div>
            </div>

            <DocSimpleParagraph className="pt-9 leading-[30px]">
              Discover startups that resonate with your vision and engage
              directly to shape the future together.
            </DocSimpleParagraph>

            <div
              style={{
                background: 'rgba(18, 19, 20, 0.6)',
                backdropFilter: 'blur(25px)',
              }}
              className="rounded-[12px] mt-12 text-[#98A2B3] pt-[22px] pb-[24px] px-[24px] h-auto sm:h-[84px] border border-[#303034] leading-[30px]"
            >
              Uncover startups aligned with your interests—our AI will tailor
              your journey. Share your preferences, and let the personalized
              discovery begin!
            </div>

            {/* <div href={`#`} className={styles.btn}>
              Submit Preferences
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
